import React, { useState } from 'react';
import { ModuleBridge, TopActionBar, Button, Flex } from '../components';

export const MigrationProfilesList = () => {
    const [migrationType, setMigrationType] = useState('full');
    const handleClick = (type) => {
        setMigrationType(type);
        window.handleMigrationTypeChange(type);
    };

    return (
        <>
            <TopActionBar>
                <Flex gap="small">
                    <Button type={migrationType === 'full' ? 'primary' : 'default'} onClick={() => handleClick('full')}>
                        Workload Migration
                    </Button>
                    <Button
                        type={migrationType === 'differential' ? 'primary' : 'default'}
                        onClick={() => handleClick('differential')}
                    >
                        Workload Delta Migration
                    </Button>
                </Flex>
            </TopActionBar>
            <div id="migration_profiles_list_container"></div>
            <ModuleBridge moduleId="migration_profiles_list_module" />
        </>
    );
};
